var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"welcome-card"},[_c('div',{staticClass:"welcome-card-content"},[_c('span',{staticClass:"header"},[_vm._v("Hello & Welcome to WatchList")]),_c('identity-buttons')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }